import INavBar from '@src/component/INavBar'
import CommonService from '@src/service/commonService'
import { Dialog, Space } from 'antd-mobile'
import QRCode from 'qrcode.react'
import { useEffect, useState } from 'react'
import './index.scss'

function IQrCode() {
  const [content, setContent] = useState('')

  useEffect(() => {
    CommonService.getQRContent().then((res) => setContent(res as string))
  }, [])

  const copy = async () => {
    await navigator.clipboard.writeText(content)
    Dialog.alert({
      content: '复制成功',
    })
  }

  return (
    <>
      <INavBar title="销售二维码" />
      <Space
        direction="vertical"
        style={{ width: '100%', '--gap': '30px' }}
        align="center"
      >
        <div className="qr-box">
          <Space
            direction="vertical"
            style={{ '--gap': '29px' }}
            align="center"
          >
            {content && (
              <QRCode
                id="qrCode"
                value={content}
                size={148} // 二维码的大小
                fgColor="#000000" // 二维码的颜色
                style={{ margin: 'auto' }}
              />
            )}
            <div className="text">
              <span>客户申请购车分期需扫描您的二维码</span>{' '}
              <span>客户扫码后将与您绑定!</span>
              <span>注：二维码有效期24小时，失效后请重新保存</span>{' '}
            </div>
          </Space>
        </div>
        <p className="qr-content" onClick={copy}>
          {content}
        </p>
      </Space>
    </>
  )
}

export default IQrCode
